var exports = {
  "Rp": "pagenav-c1k0e",
  "A7": "outer-c1k0e",
  "ss": "current-c1k0e",
  "De": "pagehit-c1k0e",
};

module.exports = exports;
